import { Injectable, Injector } from '@angular/core';
import { SdkBase } from '../utilities/sdk-base/sdk.base';
import { Observable } from 'rxjs';
import { DocumentReviewStateResource } from '@models/resource/document-review-state.resource';
import { LexbeDoc } from '@models/doc.model';
import { DocChangeSetReferenceResource } from '@models/resource/doc-change-set-reference.resource';

@Injectable({
	providedIn: 'root'
})
export class ReviewSdk extends SdkBase {
	constructor(injector: Injector) {
		super(injector);
	}

	public getDocumentReviewState$(id: string, reviewSetId?: string, projectChangeSets: DocChangeSetReferenceResource[] = []): Observable<DocumentReviewStateResource> {
		const path = `api2/state/review/${ id }`;
		return this.makeHttpRequest<any>('post', path, { documentId: id, reviewSetId, projectChangeSets });
	}

	public saveDocumentReviewState$(doc: LexbeDoc, reviewStatus: number, shouldPropagateCoding: boolean, reviewSetId?: string): Observable<void> {
		let path = `api2/state/review/${ doc.docId }/save`;

		if (reviewSetId) {
			path = `${ path }?reviewSetId=${ reviewSetId }`;
		}

		return this.makeHttpRequest<any>('post', path, { document: doc, reviewStatus, shouldPropagateCoding, reviewSetId });
	}
}
